import api from "../api";
import {createError, logError, logSuccess} from "./message";
import types from "./types";

function requestRequestCard() {
  return {
    type: types.GET_REQUEST_CARD_REQUEST,
    isFetchingRequestCard: true
  };
}

function requestRequestCardCompleted(requestCard) {
  return {
    type: types.GET_REQUEST_CARD_COMPLETED,
    isFetchingRequestCard: false,
    requestCard
  };
}

function requestRequestCardError(requestCardError) {
  return {
    type: types.GET_REQUEST_CARD_ERROR,
    isFetchingRequestCard: false,
    requestCardError
  };
}

export function getRequestCard(id) {
  return dispatch => {
    dispatch(requestRequestCard());
    return api.getRequestCard(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestRequestCardCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestRequestCardError(message));
        } else {
          logError(err);
          dispatch(requestRequestCardError(createError("Не удалось загрузить карточку")));
        }
      });
  };
}

function requestRequestSystem() {
  return {
    type: types.GET_REQUEST_SYSTEM_REQUEST,
    isFetchingMeta: true,
    createdStudent: null,
    isCreatingStudent: false,
    isFetchingWorkProcess: false,
    workProcess: null
  };
}

function requestRequestSystemCompleted(metaInfo) {
  return {
    type: types.GET_REQUEST_SYSTEM_COMPLETED,
    isFetchingMeta: false,
    metaInfo
  };
}

function requestRequestSystemError(metaInfoError) {
  return {
    type: types.GET_REQUEST_SYSTEM_ERROR,
    isFetchingMeta: false,
    metaInfoError
  };
}

export function getRequestSystemInfo(id) {
  return dispatch => {
    dispatch(requestRequestSystem());
    return api.getRequestMeta(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestRequestSystemCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestRequestSystemError(message));
        } else {
          logError(err);
          dispatch(requestRequestSystemError(createError("Не удалось загрузить данные")));
        }
      });
  };
}

function requestRequestMain() {
  return {
    type: types.GET_REQUEST_MAIN_REQUEST,
    isFetchingRequestMain: true,
    createdStudent: null,
    isCreatingStudent: false,
    isFetchingWorkProcess: false,
    workProcess: null
  };
}

function requestRequestMainCompleted(requestMain) {
  return {
    type: types.GET_REQUEST_MAIN_COMPLETED,
    isFetchingRequestMain: false,
    requestMain
  };
}

function requestRequestMainError(requestMainError) {
  return {
    type: types.GET_REQUEST_MAIN_ERROR,
    isFetchingRequestMain: false,
    requestMainError
  };
}

export function getRequestMainInfo(id) {
  return dispatch => {
    dispatch(requestRequestMain());
    return api.getRequestMain(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestRequestMainCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestRequestMainError(message));
        } else {
          logError(err);
          dispatch(requestRequestMainError(createError("Не удалось загрузить данные")));
        }
      });
  };
}

/*function requestRequestPlanCard() {
  return {
    type: types.GET_REQUEST_PLAN_CARD_REQUEST,
    isFetchingRequestPlan: true
  };
}

function requestRequestPlanCompleted(requestPlan) {
  return {
    type: types.GET_REQUEST_PLAN_CARD_COMPLETED,
    isFetchingRequestPlan: false,
    requestPlan
  };
}

function requestRequestPlanError(requestPlanError) {
  return {
    type: types.GET_REQUEST_PLAN_CARD_ERROR,
    isFetchingRequestPlan: false,
    requestPlanError
  };
}

export function getRequestPlanCard(id) {
  return dispatch => {
    dispatch(requestRequestPlanCard());
    return api.getRequestPlan(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestRequestPlanCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestRequestPlanError(message));
        } else {
          //logError(err);
          dispatch(requestRequestPlanError(createError("Не удалось загрузить карточку учебного плана")));
        }
      });
  };
}*/

function requestRequestGroupCard() {
  return {
    type: types.GET_REQUEST_GROUP_CARD_REQUEST,
    isFetchingRequestGroup: true
  };
}

function requestRequestGroupCompleted(requestGroup) {
  return {
    type: types.GET_REQUEST_GROUP_CARD_COMPLETED,
    isFetchingRequestGroup: false,
    requestGroup
  };
}

function requestRequestGroupError(requestGroupError) {
  return {
    type: types.GET_REQUEST_GROUP_CARD_ERROR,
    isFetchingRequestGroup: false,
    requestGroupError
  };
}

export function getRequestGroupCard(id) {
  return dispatch => {
    dispatch(requestRequestGroupCard());
    return api.getRequestGroup(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestRequestGroupCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestRequestGroupError(message));
        } else {
          //logError(err);
          dispatch(requestRequestGroupError(createError("Не удалось загрузить карточку группы")));
        }
      });
  };
}

function requestRequestProgramCard() {
  return {
    type: types.GET_REQUEST_PROGRAM_CARD_REQUEST,
    isFetchingRequestProgram: true
  };
}

function requestRequestProgramCompleted(requestProgram) {
  return {
    type: types.GET_REQUEST_PROGRAM_CARD_COMPLETED,
    isFetchingRequestProgram: false,
    requestProgram
  };
}

function requestRequestProgramError(requestProgramError) {
  return {
    type: types.GET_REQUEST_PROGRAM_CARD_ERROR,
    isFetchingRequestProgram: false,
    requestProgramError
  };
}

export function getRequestProgramCard(id) {
  return dispatch => {
    dispatch(requestRequestProgramCard());
    return api.getRequestProgram(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestRequestProgramCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestRequestProgramError(message));
        } else {
          //logError(err);
          dispatch(requestRequestProgramError(createError("Не удалось загрузить карточку программы")));
        }
      });
  };
}

function requestRelRequests() {
  return {
    type: types.GET_RELATION_REQUESTS_LIST_REQUEST,
    isFetchingRelRequestList: true
  };
}

function requestRelRequestsCompleted(relRequestList) {
  return {
    type: types.GET_RELATION_REQUESTS_LIST_COMPLETED,
    isFetchingRelRequestList: false,
    relRequestList
  };
}

function requestRelRequestsError(relRequestListError) {
  return {
    type: types.GET_RELATION_REQUESTS_LIST_ERROR,
    isFetchingRelRequestList: false,
    relRequestListError
  };
}

function requestRelStudents() {
  return {
    type: types.GET_RELATION_STUDENTS_LIST_REQUEST,
    isFetchingRelStudentList: true
  };
}

function requestRelStudentsCompleted(relStudentList) {
  return {
    type: types.GET_RELATION_STUDENTS_LIST_COMPLETED,
    isFetchingRelStudentList: false,
    relStudentList
  };
}

function requestRelStudentsError(relStudentListError) {
  return {
    type: types.GET_RELATION_STUDENTS_LIST_ERROR,
    isFetchingRelStudentList: false,
    relStudentListError
  };
}

export function getRelationRequestList(id) {
  return dispatch => {
    dispatch(requestRelRequests());
    return api.getRelationRequests(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestRelRequestsCompleted(resp.requestRelations));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestRelRequestsError(message));
        } else {
          logError(err);
          dispatch(requestRelRequestsError(createError("Не удалось загрузить данные")));
        }
      });
  };
}

export function getRelationStudentList(id) {
  return dispatch => {
    dispatch(requestRelStudents());
    return api.getRelationStudents(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestRelStudentsCompleted(resp.studentRelations));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestRelStudentsError(message));
        } else {
          logError(err);
          dispatch(requestRelStudentsError(createError("Не удалось загрузить данные")));
        }
      });
  };
}

function requestRequestWork() {
  return {
    type: types.GET_REQUEST_WORK_INFO_REQUEST,
    isFetchingRequestWork: true
  };
}

function requestRequestWorkCompleted(requestWork) {
  return {
    type: types.GET_REQUEST_WORK_INFO_COMPLETED,
    isFetchingRequestWork: false,
    requestWork
  };
}

function requestRequestWorkError(requestWorkError) {
  return {
    type: types.GET_REQUEST_WORK_INFO_ERROR,
    isFetchingRequestWork: false,
    requestWorkError
  };
}

export function getRequestWorkInfo(id) {
  return dispatch => {
    dispatch(requestRequestWork());
    return api.getWorkInfo(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestRequestWorkCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestRequestWorkError(message));
        } else {
          logError(err);
          dispatch(requestRequestWorkError(createError("Не удалось загрузить данные обработки заявки")));
        }
      });
  };
}

function requestWorkProcessList() {
  return {
    type: types.GET_WORK_PROCESS_LIST_REQUEST,
    isFetchingRequestWork: true
  };
}

function requestWorkProcessListCompleted(processList) {
  return {
    type: types.GET_WORK_PROCESS_LIST_COMPLETED,
    isFetchingRequestWork: false,
    processList
  };
}

function requestWorkProcessListError(processListError) {
  return {
    type: types.GET_WORK_PROCESS_LIST_ERROR,
    isFetchingRequestWork: false,
    processListError
  };
}

export function getWorkProcessList(id) {
  return dispatch => {
    dispatch(requestWorkProcessList());
    return api.getWorkProcessList(id)
      .then(response => {
        if (response.status === 200) {
          let data = response.data;
          dispatch(requestWorkProcessListCompleted(data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestWorkProcessListError(message));
        } else {
          logError(err);
          dispatch(requestWorkProcessListError(createError("Не удалось загрузить список процесса обработки заявки")));
        }
      });
  };
}

function requestSearchMatchPerson() {
  return {
    type: types.SEARCH_MATCH_PERSON_REQUEST,
    isFetchingMatchPersonList: true
  };
}

function requestSearchMatchPersonCompleted(matchPersonList) {
  return {
    type: types.SEARCH_MATCH_PERSON_COMPLETE,
    isFetchingMatchPersonList: false,
    matchPersonList
  };
}

function requestSearchMatchPersonError(matchPersonListError) {
  return {
    type: types.SEARCH_MATCH_PERSON_ERROR,
    isFetchingMatchPersonList: false,
    matchPersonListError
  };
}

export function searchMatchPerson(email, firstName, lastName, middleName) {
  return dispatch => {
    dispatch(requestSearchMatchPerson());
    return api.getMatchPersons(email, firstName, lastName, middleName)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestSearchMatchPersonCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestSearchMatchPersonError(message));
        } else {
          logError(err);
          dispatch(requestSearchMatchPersonError(createError("Не удалось загрузить данные")));
        }
      });
  };
}

function requestFilters() {
  return {
    type: types.GET_REQUEST_PROGRAM_FILTERS_REQUEST,
    isFetchingFilters: true
  };
}

function requestFiltersCompleted(filters) {
  return {
    type: types.GET_REQUEST_PROGRAM_FILTERS_COMPLETED,
    isFetchingFilters: false,
    filters
  };
}

function requestFiltersError(filtersError) {
  return {
    type: types.GET_REQUEST_PROGRAM_FILTERS_ERROR,
    isFetchingFilters: false,
    filtersError
  };
}

export function getAllFilters() {
  return dispatch => {
    dispatch(requestFilters());
    return api.getFilters()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestFiltersCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestFiltersError(message));
        } else {
          logError(err);
          dispatch(requestFiltersError(createError("Не удалось загрузить данные для фильтрации таблицы заявок")));
        }
      });
  };
}

export default {
  getRequestCard,
  getRequestSystemInfo,
  getRequestMainInfo,
  getRelationRequestList,
  getRelationStudentList,
  getRequestWorkInfo,
  getWorkProcessList,
  getRequestGroupCard,
  getRequestProgramCard,
  searchMatchPerson,
  getAllFilters
}
